import React, { useState } from 'react';

import { Block, Title, Flex, Loader, Toggle, Label } from '@upsales/components';
import useExternalIntegrations from 'App/components/hooks/integrations/useExternalIntegrations';
import { useTranslation } from 'Components/Helpers/translate';
import ExternalIntegration from './ExternalIntegration';
import BemClass from '@upsales/components/Utils/bemClass';
import './ExternalIntegrations.scss';
import { useAccountSelf } from 'App/components/hooks/appHooks';
import { useSelector } from '../hooks';
import useExternalTokens from '../hooks/integrations/useExternalTokens';

const integrationMode = 'paragon';

const ExternalIntegrations = () => {
	const classes = new BemClass('ExternalIntegrations');
	const { t } = useTranslation();
	const [globalSettingsMode, setGlobalSettingsMode] = useState(false);
	useExternalTokens();
	const { openIntegration } = useExternalIntegrations(integrationMode);

	const { connectedIntegrations, availableIntegrations, initialised, allIntegrations } = useSelector(
		state => state.ExternalIntegration
	);

	const accountSelf = useAccountSelf();
	const hasGlobalSettingAccess = accountSelf?.client?.id === 325;

	if (!allIntegrations?.length && initialised) {
		return null;
	}

	return (
		<Block space="mbxl">
			<Flex justifyContent="space-between" space="mbm" alignItems="center">
				<Title>{t('default.integrations')}</Title>
			</Flex>

			{hasGlobalSettingAccess ? (
				<Flex gap="u1" space="mbm">
					<Label>{t('default.integrations.globalSettingsMode')}</Label>
					<Toggle checked={globalSettingsMode} onChange={() => setGlobalSettingsMode(!globalSettingsMode)} />
				</Flex>
			) : null}

			{initialised ? null : (
				<Flex justifyContent="flex-start" space="mbm">
					<Loader />
				</Flex>
			)}

			<Flex gap="u2" className={classes.elem('integrations').b()}>
				{connectedIntegrations?.map(integration => (
					<ExternalIntegration
						key={integration.id}
						integration={integration}
						enabled
						onClick={integration => openIntegration(integration, globalSettingsMode)}
					/>
				))}
				{availableIntegrations?.map(integration => (
					<ExternalIntegration
						key={integration.id}
						integration={integration}
						onClick={integration => openIntegration(integration, globalSettingsMode)}
					/>
				))}
			</Flex>
		</Block>
	);
};

export default ExternalIntegrations;
